export default "__VITE_ASSET__Ul8iXDuw__"